
<div
  id="app"
  class="wsk-root wsk-app ws-fields-arrangement"
  :class="'theme--' + conf.theme"
>
  <layout-default />
  <ws-outdated-modal />
  <theme-switcher v-if="$store.state.devUtils" />
</div>
